export default {

    images: [
        {
          src: require(`@/assets/desc_carousel_images/1.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/2.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/3.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/4.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/5.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/6.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/7.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/8.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/9.png`),
        },
        {
            src: require(`@/assets/desc_carousel_images/10.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/11.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/12.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/13.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/14.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/15.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/16.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/17.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/18.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/19.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/20.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/21.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/22.png`),
        },
        {
          src: require(`@/assets/desc_carousel_images/23.png`),
        },
    ]
}